@if (signUp()) {
  <lib-signup-form (signup)="doSignup($event)" [otpConfig]="config.otpConfig"></lib-signup-form>
  <span i18n="account exists link@@accountExists">Heb je al een account? </span>
  <tngh-button
    variant="link"
    label="Log dan nu in"
    (clickEvent)="signIn()"
    i18n-label="sing in link for existing accounts@@signInExistingAccount"
  ></tngh-button>
} @else {
  <lib-otp-form
    (sendOtpRequest)="doSendOtpRequest($event)"
    (loginRequest)="doLoginRequest($event)"
    (signup)="handleSignUp()"
    [signupUrl]="signupUrl()"
    [readyForOtp]="readyForOtp()"
    [loginError]="loginError()"
    [theme]="config.theme ?? ''"
    [otpConfig]="config.otpConfig"
  ></lib-otp-form>
}
